import { Injectable, computed, Signal } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PrivilegeService {
  
  constructor(private authService: AuthService) {}

  /**
   * Check if the current user has the specific privilege
   * @param privilege The privilege key to check (e.g., 'edit_doctor')
   * @returns true if user has the privilege
   */
  hasPrivilege(privilege: string): boolean {
    const user = this.authService.currentUser();
    // If user is super admin or similar, you might want to return true always
    // For now, we strictly check the privileges array
    const privileges = user?.privileges || [];
    return privileges.includes(privilege);
  }

  /**
   * Check if user has any of the provided privileges
   * @param privileges Array of privilege keys
   */
  hasAnyPrivilege(privileges: string[]): boolean {
    const user = this.authService.currentUser();
    const userPrivileges = user?.privileges || [];
    return privileges.some(p => userPrivileges.includes(p));
  }

  /**
   * Check if user has all of the provided privileges
   * @param privileges Array of privilege keys
   */
  hasAllPrivileges(privileges: string[]): boolean {
    const user = this.authService.currentUser();
    const userPrivileges = user?.privileges || [];
    return privileges.every(p => userPrivileges.includes(p));
  }

  /**
   * Check if the current user has permission to export data.
   */
  canExport(): boolean {
    return this.authService.canExport();
  }
}
